/** Traductions modale enregistrement paiement (FR / AR) */
export const paymentModalFr = {
  paymentTitle: 'Enregistrer Paiement',
  consolidated: 'Consolidé',
  remaining: 'Restant',
  total: 'Total',
  paidCol: 'Payé',
  remainingAmount: 'Montant Restant',
  paymentAmount: 'Montant du Paiement',
  paymentMethod: 'Méthode de Paiement',
  cancel: 'Annuler',
  paymentRecorded: 'Paiement enregistré',
  paying: 'Traitement...',
  allocationFifoHint: 'Le montant est déduit automatiquement de la facture ouverte la plus ancienne',
  changeInvoice: 'Changer de facture',
  fullBalance: 'Solde',
  moreOptions: 'Plus d\'options',
  payNow: 'Enregistrer le paiement',
  colDate: 'Date',
  viewInvoice: 'Voir facture',
  consolidatedIncludesHint: 'Les factures individuelles sont regroupées — paiement uniquement ici.',
  availableTitle: 'Disponible par méthode',
  availableCash: 'Espèces',
  availableElectronic: 'Total électronique',
  electronicUnspecified: 'Électronique (non précisé)',
  availableSelected: 'Sur la méthode choisie',
  insufficientSelected: 'Montant supérieur au disponible sur {{method}} ({{available}}).',
  suggestUseMethod: 'Utiliser {{method}} ({{available}} disponible)',
  crossMethodHint: 'Répartition proposée : {{split}}',
  externalHint: 'Financement externe : {{amount}} (hors caisse)',
  externalModeOk:
    'Financement externe OK : {{amount}} — le solde caisse / électronique n\'est pas réduit.',
  blockedHint: 'Montant trop élevé : total disponible toutes méthodes {{total}}.',
  noSalesSetupHint: 'Phase installation : choisissez Capital démarrage ou Financement externe.',
  fundingSourceLabel: 'Source du financement',
  fundingRegister: 'Caisse (solde)',
  fundingOpeningCapital: 'Capital démarrage',
  fundingExternal: 'Financement externe',
  fundingRegisterDesc: 'Déduit du solde Espèces / électronique — met à jour la caisse.',
  fundingOpeningCapitalRemaining: 'Capital démarrage restant',
  fundingExternalDesc: 'Hors caisse et hors capital démarrage (toutes méthodes).',
  openingCapitalHint: 'Payé depuis le capital démarrage : {{amount}} (n\'entre pas dans le solde).',
  allocationModeAria: 'Mode d\'allocation du paiement',
  paymentChannelAria: 'Canal de paiement',
  channelCash: 'Espèces',
  channelElectronic: 'Électronique',
  selectProvider: 'Choisir le prestataire',
  checkAvailability: 'Vérifier disponibilité',
  pressEnterToCheck: 'Entrée pour vérifier le disponible',
  selectInvoiceHint: 'Sélectionnez une facture dans la liste',
  availabilityStale: 'Données modifiées — appuyez sur Entrée pour revérifier',
  filterPlaceholder: 'Filtrer n° facture ou fournisseur…',
  invoicesToPay: 'facture(s) à payer',
  colInvoice: 'Facture',
  colSupplier: 'Fournisseur',
  colRemaining: 'Restant',
  noOpenInvoices: 'Aucune facture ouverte',
  noFilterResults: 'Aucun résultat pour ce filtre',
  autoFifo: 'Auto FIFO',
  targetInvoice: 'Facture cible',
  maxLabel: 'Max',
  receipt: 'Reçu',
  hideHistory: 'Masquer',
  showHistory: 'Historique',
  confirmSetupPhase: 'Phase installation : capital démarrage — {{amount}}',
  confirmOpeningCapital: 'Payer depuis le capital démarrage : {{amount}} ?',
  confirmExternalOnly: 'Financement externe (hors caisse) : {{amount}} ?',
  confirmCrossMethod: 'Le montant ({{amount}}) dépasse le disponible sur la méthode choisie. Répartition proposée : {{split}}',
  confirmExternalAddon: ', externe : {{amount}}',
  confirmRegisterAndExternal: 'Depuis caisse : {{register}}, financement externe : {{external}}',
  errAmountPositive: 'Entrez un montant supérieur à 0',
  errSelectSourceInvoice: 'Sélectionnez une facture source',
  errExceedsTargetRemaining: 'Le montant dépasse le restant de la facture sélectionnée',
  errExceedsRemaining: 'Le montant dépasse le restant',
  warnEnterAmountCheck: 'Entrez un montant puis Entrée pour vérifier le disponible',
  blockedExceedsTotal: 'Montant supérieur au total disponible ({{total}}) sur toutes les méthodes.',
  blockedTryMethods: ' Essayez : {{methods}}',
  errReceiptTooLarge: 'Fichier trop volumineux (max. 2 Mo)',
  errReceiptInvalidType: 'Type de fichier non pris en charge',
  errReceiptReadFailed: 'Échec de lecture du reçu de paiement',
  errAlreadyRecorded: 'Ce paiement a déjà été enregistré',
  errCashRegisterUpdateFailed: 'Échec de la mise à jour de la caisse — paiement non enregistré',
  errSavePaymentFailed: 'Échec de l\'enregistrement du paiement',
  errPaymentGeneric: 'Erreur lors du paiement'
};

export const paymentModalAr = {
  paymentTitle: 'تسجيل الدفع',
  consolidated: 'مدمج',
  remaining: 'المتبقي',
  total: 'المجموع',
  paidCol: 'المدفوع',
  remainingAmount: 'المبلغ المتبقي',
  paymentAmount: 'مبلغ الدفع',
  paymentMethod: 'طريقة الدفع',
  cancel: 'إلغاء',
  paymentRecorded: 'تم تسجيل الدفع',
  paying: 'جاري المعالجة...',
  allocationFifoHint: 'يُخصم المبلغ تلقائياً من أقدم فاتورة غير مدفوعة',
  changeInvoice: 'تغيير الفاتورة',
  fullBalance: 'الكامل',
  moreOptions: 'خيارات إضافية',
  payNow: 'تسجيل الدفع',
  colDate: 'التاريخ',
  viewInvoice: 'عرض الفاتورة',
  consolidatedIncludesHint: 'الفواتير الفردية مدمجة — الدفع من هنا فقط.',
  availableTitle: 'المتاح حسب طريقة الدفع',
  availableCash: 'نقداً',
  availableElectronic: 'إجمالي الإلكتروني',
  electronicUnspecified: 'إلكتروني (غير محدد)',
  availableSelected: 'على الطريقة المختارة',
  insufficientSelected: 'المبلغ أكبر من المتاح على {{method}} ({{available}}).',
  suggestUseMethod: 'استخدم {{method}} ({{available}} متاح)',
  crossMethodHint: 'التوزيع المقترح: {{split}}',
  externalHint: 'تمويل خارجي: {{amount}} (خارج الصندوق)',
  externalModeOk:
    'تمويل خارجي جاهز: {{amount}} — رصيد الصندوق / الإلكتروني لا ينخفض.',
  blockedHint: 'المبلغ كبير جداً: إجمالي المتاح {{total}}.',
  noSalesSetupHint: 'مرحلة التثبيت: اختر رأس مال البدء أو التمويل الخارجي.',
  fundingSourceLabel: 'مصدر التمويل',
  fundingRegister: 'الصندوق (الرصيد)',
  fundingOpeningCapital: 'رأس مال البدء',
  fundingExternal: 'تمويل خارجي',
  fundingRegisterDesc: 'يُخصم من رصيد النقد / الإلكتروني — يحدّث الصندوق.',
  fundingOpeningCapitalRemaining: 'رأس مال البدء المتبقي',
  fundingExternalDesc: 'خارج الصندوق وخارج رأس مال البدء (كل الطرق).',
  openingCapitalHint: 'مدفوع من رأس مال البدء: {{amount}} (لا يدخل في الرصيد).',
  allocationModeAria: 'وضع توزيع الدفع',
  paymentChannelAria: 'قناة الدفع',
  channelCash: 'نقداً',
  channelElectronic: 'إلكتروني',
  selectProvider: 'اختر مزود الدفع',
  checkAvailability: 'تحقق من المتاح',
  pressEnterToCheck: 'Enter للتحقق من المتاح',
  selectInvoiceHint: 'اختر فاتورة من القائمة',
  availabilityStale: 'تغيّرت البيانات — اضغط Enter للتحقق مجدداً',
  filterPlaceholder: 'تصفية برقم الفاتورة أو المورد…',
  invoicesToPay: 'فاتورة للدفع',
  colInvoice: 'الفاتورة',
  colSupplier: 'المورد',
  colRemaining: 'المتبقي',
  noOpenInvoices: 'لا توجد فواتير مفتوحة',
  noFilterResults: 'لا نتائج لهذا البحث',
  autoFifo: 'تلقائي FIFO',
  targetInvoice: 'فاتورة محددة',
  maxLabel: 'الحد الأقصى',
  receipt: 'إيصال',
  hideHistory: 'إخفاء',
  showHistory: 'السجل',
  confirmSetupPhase: 'مرحلة التثبيت: رأس مال البدء — {{amount}}',
  confirmOpeningCapital: 'الدفع من رأس مال البدء: {{amount}}؟',
  confirmExternalOnly: 'تمويل خارجي (خارج الصندوق): {{amount}}؟',
  confirmCrossMethod: 'المبلغ ({{amount}}) أكبر من المتاح على الطريقة المختارة. التوزيع المقترح: {{split}}',
  confirmExternalAddon: '، خارجي: {{amount}}',
  confirmRegisterAndExternal: 'من الصندوق: {{register}}، تمويل خارجي: {{external}}',
  errAmountPositive: 'أدخل مبلغاً أكبر من صفر',
  errSelectSourceInvoice: 'اختر فاتورة للدفع',
  errExceedsTargetRemaining: 'المبلغ أكبر من متبقي الفاتورة المحددة',
  errExceedsRemaining: 'المبلغ أكبر من المتبقي',
  warnEnterAmountCheck: 'أدخل مبلغاً ثم اضغط Enter للتحقق',
  blockedExceedsTotal: 'المبلغ أكبر من إجمالي المتاح ({{total}}) عبر جميع طرق الدفع.',
  blockedTryMethods: ' جرّب: {{methods}}',
  errReceiptTooLarge: 'ملف الإيصال كبير جداً (الحد 2 ميغابايت)',
  errReceiptInvalidType: 'نوع الملف غير مدعوم',
  errReceiptReadFailed: 'فشل قراءة إيصال الدفع',
  errAlreadyRecorded: 'تم تسجيل هذا الدفع مسبقاً',
  errCashRegisterUpdateFailed: 'فشل تحديث الصندوق — لم يُسجَّل الدفع',
  errSavePaymentFailed: 'فشل حفظ الدفع',
  errPaymentGeneric: 'خطأ أثناء الدفع'
};
